<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchTitle"></breadcrumb-search>
      <div style="display: flex; padding-bottom: 24px">
        <div v-for="(item, index) in records" :key="index" class="record-item">
          <div>
            <img style="width: 56px; height: 56px" :src="item.img" />
          </div>
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <div class="price">
              <span style="font-size: 16px">￥</span>{{ item.price }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <el-button
            type="primary"
            icon="el-icon-upload2"
            :loading="exporting"
            @click="exportFn"
            >导出</el-button
          >
        </div>
      </div>
      <div id="base-list">
        <lb-table
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage"
          :page-size="page.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    breadcrumbSearch,
    LbTable,
  },
  data () {
    return {
      dataList: {
        list: [
          { title: '财务管理', path: '', type: '0' },
          { title: '平台结算金', path: '', type: '1' }
        ]
      },
      searchList: {
        list: [
          { title: '数据筛选', path: '', type: '0' }
        ]
      },
      records: [
        {
          img: require('../../../assets/icon_jiesuan.png'),
          title: '结算总额',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_daijiesuan.png'),
          title: '待结算金额',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_yitixian.png'),
          title: '已提现金额',
          price: '10000'
        },
        {
          img: require('../../../assets/icon_shengyu.png'),
          title: '剩余金额',
          price: '10000'
        },
      ],
      searchTitle: {
        list: [
          { title: '平台结算金', path: '', type: '0' }
        ]
      },
      list: [],
      value1: [],
      brandList: [],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        {
          label: '商品信息',
          minWidth: '220',
          render: (h, scope) => {
            return (
              <div style="display:flex;align-items:center">
                <el-image src={scope.row.mainImage} preview-src-list={[scope.row.mainImage]} lazy style="width:64px;height:64px;"></el-image>
                <div style="display:flex:justify-content:space-between;font-size:14px;margin-left:8px;flex:1;">
                  <p style="width:100%;text-align:left;">{scope.row.name}</p>
                  <p style="color:#606066;text-align:left;">平台商品编号：{scope.row.platformNo}</p>
                </div>
              </div>
            )
          }
        },
        { label: '五域商品编号', prop: 'the5EGoodsNo', width: '120' },
        { label: '上架时间', prop: 'putOnTime', width: '170' },
        {
          label: '成本价（元）', prop: 'categoryName', minWidth: '150',
          render: (h, scope) => {
            return (
              <div>{scope.row.minCostPrice} - {scope.row.maxCostPrice}</div>
            )
          }
        },
        { label: '平台销售数量', prop: 'platformSoldNum', minWidth: '120' },
        { label: '五域销售数量', prop: 'the5ESoldNum', minWidth: '120' },
        { label: '销售总数量', prop: 'totalSoldNum', minWidth: '120' },
        { label: '待结算金额（元）', prop: 'awaitSettleAmount', minWidth: '150' },
        { label: '结算金额（元）', prop: 'settledAmount', minWidth: '120' },
        {
          label: '操作',
          align: 'center',
          fixed: 'right',
          render: (h, scope) => {
            return (
              <div>
                <span style='color:#2D46EE;cursor:pointer;' onClick={() => { this.toOtherPages('platformSettlementFundDetail', scope.row.id, 'edit') }}>详情</span>
              </div>
            )
          }
        }
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      exporting: false
    }
  },
  created () {
    this.getStatistics()
    this.getPageList()
  },
  methods: {
    exportFn () {
      this.exporting = true;
      this.axios.get('/settlements/exportList')
        .then(res => {
          console.log(res)
          this.exporting = false;
          if (res.code == 0) {
            this.downloadlink(res.data)
          }
        })
    },
    getPageList () {
      let data = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      this.axios.post('/settlements/getPageList', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    },
    onMultipleSelection (e) { },
    handleSizeChange (e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getPageList();
    },
    handleCurrentChange (e) {
      this.page.pageNo = e;
      this.getPageList();
    },
    getStatistics () {
      this.axios.get('/settlements/getStatistics')
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.records[0].price = res.data.totalMoney;
            this.records[1].price = res.data.awaitMoney;
            this.records[2].price = res.data.paidMoney;
            this.records[3].price = res.data.activeMoney;
          }
        })
    },
    toOtherPages (name, parameter, type) {
      this.$router.push({
        name,
        query: { id: parameter, type }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.record-item {
  display: flex;
  width: 313px;
  height: 88px;
  background: #ffffff;
  box-shadow: 0px 3px 12px rgba(0, 0, 0, 0.05);
  opacity: 1;
  border-radius: 6px;
  margin-right: 18px;
  img {
    padding: 16px 14px;
  }
  .right {
    margin-top: 16px;
    .title {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 21px;
      color: #303033;
    }
    .price {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 31px;
      color: #303033;
      margin-top: 8px;
    }
  }
}
.title {
  display: flex;
  justify-content: space-between;
}
#base-list {
  margin-top: 20px;
}
:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;
  a {
    margin: 0 5px;
  }
}
.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }
    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;
      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
/deep/ .el-table{
  color:#303033
}
</style>

